import {
  FC,
  HTMLAttributes,
  PropsWithChildren,
  ReactEventHandler,
} from 'react';
import { Typography } from '@mui/material';

import CloseButton from '@/Molecules/CloseButton/CloseButton';

import useStyles from './styles';

type Props = {
  onClose?: ReactEventHandler;
};

const GradientBanner: FC<
  PropsWithChildren<Props & HTMLAttributes<HTMLDivElement>>
> = ({ onClose, children, className }) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.gradientBanner, className)}>
      <Typography
        variant="bodyLgBold"
        component="span"
        className={classes.typo}
      >
        {children}
      </Typography>
      {!!onClose && (
        <CloseButton onClick={onClose} className={classes.closeIcon} />
      )}
    </div>
  );
};

export default GradientBanner;
